module.exports = __webpack_public_path__ + "assets/ad8670fb5be3116a11fca06d972c7f04.png";